import React, { useState, useEffect } from "react";
import { Input, Upload, Button, Form } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const CoverEditor = ({ slide, updateSlide, triggerSave }) => {
  const [formData, setFormData] = useState(slide);

  useEffect(() => {
    setFormData(slide);
  }, [slide]);

  useEffect(() => {
    if (triggerSave) {
      updateSlide(slide.id, formData);
    }
  }, [triggerSave]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleImageUpload = (file, key) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setFormData((prev) => ({ ...prev, [key]: e.target.result }));
    };
    reader.readAsDataURL(file);
    return false;
  };

  const handleUpdate = () => {
    updateSlide(slide.id, formData);
  };

  return (
    <div className="bg-white shadow-md rounded-xl p-4 mb-4 border border-gray-200">
      <h3 className="text-lg font-semibold mb-3 text-gray-700">
        Cover Slide Editor
      </h3>

      <Form layout="vertical" className="space-y-3">
        <Form.Item label="Main Heading">
          <Input
            value={formData.heading}
            onChange={(e) => handleChange("heading", e.target.value)}
            placeholder="Enter main heading"
          />
        </Form.Item>

        <Form.Item label="Sub Heading">
          <Input
            value={formData.subHeading}
            onChange={(e) => handleChange("subHeading", e.target.value)}
            placeholder="Enter sub heading"
          />
        </Form.Item>

        <Form.Item label="Highlight Line 1">
          <Input
            value={formData.highlight}
            onChange={(e) => handleChange("highlight", e.target.value)}
            placeholder="Enter highlight text"
          />
        </Form.Item>

        <Form.Item label="Highlight Line 2">
          <Input
            value={formData.highlight2}
            onChange={(e) => handleChange("highlight2", e.target.value)}
            placeholder="Enter second highlight text"
          />
        </Form.Item>

        <Form.Item label="Date">
          <Input
            value={formData.date}
            onChange={(e) => handleChange("date", e.target.value)}
            placeholder="Enter date"
          />
        </Form.Item>

        <Form.Item label="Tagline / Description">
          <Input.TextArea
            value={formData.tagline}
            onChange={(e) => handleChange("tagline", e.target.value)}
            placeholder="Enter tagline"
            rows={3}
          />
        </Form.Item>

        <div className="grid grid-cols-2 gap-4 mt-3">
          <div>
            <Form.Item label="Background Image">
              <Upload
                beforeUpload={(file) => handleImageUpload(file, "bg")}
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>Upload Background</Button>
              </Upload>
              {formData.bg && (
                <img
                  src={formData.bg}
                  alt="Background Preview"
                  className="mt-2 w-full h-32 max-w-xs object-cover rounded-lg border"
                />
              )}
            </Form.Item>
          </div>

          <div>
            <Form.Item label="Logo">
              <Upload
                beforeUpload={(file) => handleImageUpload(file, "logo")}
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>Upload Logo</Button>
              </Upload>
              {formData.logo && (
                <img
                  src={formData.logo}
                  alt="Logo Preview"
                  className="mt-2 max-h-xs w-full h-32 max-w-xs object-cover rounded-lg border"
                />
              )}
            </Form.Item>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default CoverEditor;
